export default __webpack_public_path__ + "static/media/be.8570b1b8.jpg";